import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { saveQuoteMobileVisibleChanged, setPowerUpErrors } from '../../actions';

import './SaveYourQuoteButton.css';
import { validatePowerupsSelected } from '../../util';

const SaveYourQuoteButton = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('quoting');
  const {
    data,
    petQuoteSelected,
  } = useSelector(({ quoting }) => quoting, shallowEqual);

  const handleSaveYourQuote = useCallback(() => {
    const petQuoteRateItem = data.ebPetQuoteResponseList
      .find((pqRateItem) => pqRateItem.petQuoteId === petQuoteSelected);
    const powerUpValidation = validatePowerupsSelected(petQuoteRateItem);
    if (!powerUpValidation.isValid) {
      dispatch(setPowerUpErrors(powerUpValidation.modifierIdNotSelectedList));
      return;
    }
    dispatch(saveQuoteMobileVisibleChanged(true));
  }, [data, dispatch, petQuoteSelected]);

  return (
    <section
      aria-label={t('saveQuoteDetails')}
      className="Save-your-quote-button-container"
    >
      <span>{t('saveQuote.notReady')}</span>

      <button
        aria-controls="saveYourQuotemodalContainer"
        className="Card-plan-footer-email-your-quote-button"
        id="saveYourQuoteTabletButton"
        onClick={handleSaveYourQuote}
        type="button"
      >
        {t('saveQuote.sendQuote')}
      </button>
    </section>
  );
};

export { SaveYourQuoteButton };
